import { render, staticRenderFns } from "./boardPush.vue?vue&type=template&id=0e45e002&scoped=true&"
import script from "./boardPush.vue?vue&type=script&lang=js&"
export * from "./boardPush.vue?vue&type=script&lang=js&"
import style0 from "./boardPush.vue?vue&type=style&index=0&id=0e45e002&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e45e002",
  null
  
)

export default component.exports